import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';

@Component({
  name: 'ChatTimestampsComponent'
})

export default class ChatTimestampsComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private displayTimestamps: boolean = true;

  protected async created() {
    this.displayTimestamps = this.userPreferences.displayTimestamps;
  }

  public saveSettings() {
    this.userPreferences.displayTimestamps = this.displayTimestamps;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/chat-timestamps/chat-timestamps.component.ts